import { render } from "./AddVehcleTaskView.vue?vue&type=template&id=6cdcaf1d&scoped=true"
import script from "./AddVehcleTaskView.vue?vue&type=script&lang=js"
export * from "./AddVehcleTaskView.vue?vue&type=script&lang=js"

import "./AddVehcleTaskView.vue?vue&type=style&index=0&id=6cdcaf1d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cdcaf1d"]])

export default __exports__